import React, { useState } from 'react';

const Checkbox = ({ label, value, index, note, onToggle }) => {
    const [checked, setChecked] = useState(false);

    const checkboxNote = {
        color: '#e0861a',
        fontStyle: 'normal',
        fontSize: 13
    };

    const flexDisplay = {
        display: 'flex'
    };

    const narrowBottomMargin = {
        marginTop: 7,
        marginBottom: 7
    };

    return (
        <div className="input-list col-lg-6 col-md-6 col-xs-12 col-sm-12" style={flexDisplay}>
            <input
                id={index}
                className="visuallyhidden"
                value={value}
                type="checkbox"
                title={label}
                name={`${label}-checkbox`}
                data-testid={index}
                onChange={(ev) => {
                    onToggle(ev.target.checked);
                    setChecked(ev.target.checked);
                }}
            />
            <label
                className={`checkbox Box--agreement border-wrapper ${checked ? 'border-active ' : ''}`}
                htmlFor={index}
                style={narrowBottomMargin}
            >
                <span>{label}</span>
                {note ? <span style={checkboxNote}>{note}</span> : null}
            </label>
        </div>
    );
};

export default Checkbox;
